<template>
  <div>
    <header class="maui-bar aui-bar aui-bar-nav">
      <div class="aui-title">行业人脉</div>
      <a
        class="aui-pull-right aui-btn"
        href="javascript:void(0);"
        @click="addressclose"
        v-if="showclose"
      >
        <span class="aui-iconfont aui-icon-close aui-icon-right"></span>
      </a>
    </header>
    <div class="maui-search aui-searchbar">
      <div class="aui-searchbar-input aui-border-radius">
        <form action="javascript:search();">
          <input
            type="search"
            placeholder="请输入搜索内容"
            id="search-input"
            v-model="kyeWord"
            @focus="seefocus"
          />
        </form>
        <div class="aui-searchbar-cancel" @click="onserach">
          <button type="submit" class="btn btn-default">
            <i class="aui-iconfont aui-icon-search"></i>
          </button>
        </div>
      </div>
    </div>
    <router-view :childrouter="kyeWord"></router-view>
  </div>
</template>

<script>
export default {
  name: "addresslist",
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      comments: [],
      showPage: 1,
      pageSize: 10,
      pageindex: 1,
      loading: false,
      finished: false,
      totalElements: "",
      kyeWord: "",
      showclose: false
    };
  },
  // created() {
  //   this.getComments();
  // },
  methods: {
    addressclose() {
      this.$router.push("/addresslist");
      this.showclose = false;
      this.kyeWord = "";
    },
    seefocus() {
      this.showclose = true;
      this.$router.push("/addresslistnull");
    },
    onserach() {
      if (this.kyeWord == "") {
        this.$message({
          message: "请输入您想搜索的内容！",
          type: "warning"
        });
      } else {
        this.$router.push("/searchaddresslistList");
      }
    }
  }
};
</script>

<style scoped>
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title {
  font-size: 0.75rem;
}
.aui-list-item-text.maui-company {
  line-height: 1.2rem;
  font-size: 0.6rem;
  color: #4f4f4f;
  justify-content: flex-start;
}
.aui-list .aui-list-item-media {
  width: 6.5rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.maui-tel {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-tel i {
  color: #3ec26d;
  margin-right: 0.2rem;
}

.aui-list .aui-list-item-media.maui-directories-media {
  width: 3.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-directories-media img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
}

.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-name {
  font-size: 0.8rem;
  margin-right: 0.5rem;
}
.maui-title {
  font-size: 0.6rem;
}

@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/addresslist.vue